import React from 'react';

import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

CustomTitle.defaultProps = {
  align: 'center',
  variant: 'subtitle1',
  color: 'primary',
};

CustomTitle.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
};

export default function CustomTitle({ children, ...props }) {
  return (
    <Typography
      align={props.align}
      variant={props.variant}
      color={props.color}
      gutterBottom={props.gutterBottom}
      noWrap={true}
    >{children.label}</Typography>
  );
}